import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/sendBox/AddAttachmentButton.module_built.css";
const classes = {"sendbox__add-attachment-input":"wTxWh-G_sendbox__add-attachment-input","sendbox__add-attachment":"wTxWh-G_sendbox__add-attachment"}
export default classes

const _sendbox__add_attachment_input0 = classes["sendbox__add-attachment-input"]
export { _sendbox__add_attachment_input0 as "sendbox__add-attachment-input" }

const _sendbox__add_attachment0 = classes["sendbox__add-attachment"]
export { _sendbox__add_attachment0 as "sendbox__add-attachment" }
